import { logError } from 'utils/logger'

let wakeLock: WakeLockSentinel | null = null
let lockListenerSet = false

const requestScreenWake = async () => {
  try {
    wakeLock = await navigator.wakeLock.request('screen')

    wakeLock.addEventListener('release', () => {
      wakeLock = null
    })
  } catch (error) {
    logError('requestScreenWake', error)
  }
}

const releaseScreenWake = () => {
  if (wakeLock) {
    wakeLock.release()
    wakeLock = null
  }
}

const onVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    requestScreenWake()
  } else {
    releaseScreenWake()
  }
}

export const enableScreenWake = () => {
  if (lockListenerSet) return
  document.addEventListener('visibilitychange', onVisibilityChange)
  lockListenerSet = true
  requestScreenWake()
}

export const disableScreenWake = () => {
  if (!lockListenerSet) return
  document.removeEventListener('visibilitychange', onVisibilityChange)
  lockListenerSet = false
  releaseScreenWake()
}
